import { Icon } from 'veui'
import { IconNeutralFace } from 'dls-icons-vue'

Icon.register('neutral-face', IconNeutralFace)
